import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import Underline from '@tiptap/extension-underline';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { FormControl, } from '@tribeplatform/react-ui-kit/FormControl';
export const SimpleHtmlEditor = ({ placeholder, name, defaultValue, validation, label, helperText, }) => {
    const [focused, setFocused] = useState(false);
    const { register, setValue, formState } = useFormContext();
    const error = formState.errors[name];
    const invalid = !!(error === null || error === void 0 ? void 0 : error.message);
    useEffect(() => {
        register(name, validation);
    }, [register, validation, name]);
    const editor = useEditor({
        onUpdate: ({ editor }) => {
            setValue(name, editor.isEmpty ? undefined : editor.getHTML());
        },
        onFocus: () => {
            setFocused(true);
        },
        onBlur: () => {
            setFocused(false);
        },
        extensions: [
            StarterKit,
            Underline,
            Link,
            Placeholder.configure({
                placeholder,
            }),
        ],
        content: defaultValue,
    });
    if (!editor)
        return null;
    return (_jsxs("div", { children: [label ? (_jsx(FormControl.Label, { htmlFor: name, children: label }, void 0)) : null, _jsxs("div", { className: clsx(!!label && 'mt-1'), children: [_jsx("div", { 
                        // h-28 is not working !?
                        style: { minHeight: '114px' }, className: clsx('flex relative shadow-sm h-28 px-3 py-2 border w-full rounded-md text-basicSurface-500 bg-surface-50 placeholder-basicSurface-300/75 border-basicSurface-300/25', focused &&
                            'outline border-actionPrimary-500 ring-actionPrimary-500', invalid && 'pr-10 outline ring-danger-500 border-danger-500'), children: _jsx(EditorContent, { editor: editor, className: "flex-1" }, void 0) }, void 0), _jsx(FormControl.Meta, { invalid: invalid, error: error === null || error === void 0 ? void 0 : error.message, helperText: helperText }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=SimpleHtmlEditor.js.map